"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 9
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.192 4.688l3.431 3.103L10.405.297"
  }));
}

var MemoSvgCheckbox = /*#__PURE__*/React.memo(SvgCheckbox);
var _default = MemoSvgCheckbox;
exports["default"] = _default;